import { render } from "./Canvases.vue?vue&type=template&id=5cca6e04"
import script from "./Canvases.vue?vue&type=script&lang=js"
export * from "./Canvases.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__